import React from 'react';
import { Link } from 'react-router-dom';

const ComingSoonMain = ( ) => {
    return (
        <>
            {/*Error Page Start*/}
                <section className="error-page">
                    <div className="error-page-shape-one float-bob-x">
                    </div>
                    <div className="container">
                    <div className="row">
                        <div className="col-xl-12">
                        <div className="error-page__inner">
                            <div className="error-page__title-box">
                            <h2 style={{fontSize: '200px'}} className="error-page__title">Coming Soon</h2>
                            </div>
                            <h3 className="error-page__tagline">
                            This Site is under construction.
                            </h3>
                            <p className="error-page__text">
                            Please check back soon. We are working on it.
                            </p>
                            <form className="error-page__form">
                            <div className="error-page__form-input">
                                <input type="search" placeholder="Search here" />
                                <button type="submit">
                                <i className="fas fa-search" />
                                </button>
                            </div>
                            </form>
                            <Link to="/" className="renoxweb-blue-btn mt-5">
                            Back to home <span />
                            </Link>
                        </div>
                        </div>
                    </div>
                    </div>
                </section>
            {/*Error Page End*/}
        </>


    );
}

export default ComingSoonMain;